import { style } from 'styled-system';
import theme from 'utils/styles/theme';

export const cursor = style({
	prop: 'cursor',
	cssProperty: 'cursor',
	alias: 'c',
	scale: theme.cursor
});


